import React from "react";

const HText = ({ children }) => {
	return <div className="heading__text">{children}</div>;
};

export default HText;
